<template>
  <div id="app">
    <!--路由的出口-->
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    // 关闭所有的右击事件
    document.getElementById("app").oncontextmenu = function(e) {
      e.preventDefault();
    };
    // 计算屏幕的缩放比例
    this.$store.commit("SET_SCALE", document.body.clientWidth / 1920);
    // 监听窗口变换
    window.onresize = () => {
      return (() => {
        this.$store.commit("SET_SCALE", document.body.clientWidth / 1920);
      })();
    };
  }
};
</script>
<style lang="scss">
#app {
  overflow: hidden;
  height: 100%;
}

  /deep/ .ant-input[disabled] {
    color: deepskyblue;
    background-color: #fff;
    border: 0;
    font-size: 14px;
    font-weight: 700;
    cursor: not-allowed;
    opacity: 1;
  }
</style>
